// Startpage.js

'use strict';

const Cookie = require('Vendor/js-cookie');

const StartPageEngineCookie = 'startpage-search-engine';
const StartPageTypeCookie = 'startpage-search-type';

module.exports = StartPage;

function StartPage() {
	this.init = function() {
		$('.js-change-engine a').on('click', this.changeEngine.bind(this));
		$('.js-change-engine-type button').on('click', this.changeEngineType.bind(this));

		$('#modal-pre-shop').on('show.bs.modal', e => {
			var rurl = '?rurl=' + encodeURIComponent(e.relatedTarget.dataset.url);
			
			$('#js-login').attr('href', '/login' + rurl)
			$('#js-signup').attr('href', '/join' + rurl)
			$('#js-clickthrough').attr('href', e.relatedTarget.dataset.url)
		});

		$('.js-add-to-homepage').on('click', e => {
			Cookie.set('show-bubble', true, {expires:0.0001});
			window.scrollTo(0, 0);
			location.reload();
		});
	}

	this.changeEngineType = function(e) {
		console.log('StartPage.changeEngineType()', e);

		let btn = $(e.currentTarget);
		let data = btn.data();
		let searchEngine = Cookie.get(StartPageEngineCookie);
		let alreadySelected = btn.hasClass('bg-blue-10');

		if(data.type == 'web') {
			if(!searchEngine || searchEngine == 'gayl') {
				searchEngine = 'google';
			}
		}
		else {
			searchEngine = 'gayl';
		}

		Cookie.set(StartPageTypeCookie, data.type, {expires: 365});

		$('[data-uri='+searchEngine+']').trigger('click');

		if(alreadySelected && $('#q').val().length) {
			$('#js-search').trigger('submit');
		}
	}

	this.changeEngine = function(e) {
		console.log('StartPage.changeEngine()', e);

		let btn = $(e.currentTarget);
		let data = btn.data();
		let form = $('#js-search');
		let input = $('#q');
		let icon = $('.searchbox-icon .dropdown-toggle i');
		let text = 'Search ' + data.engine;
		let cssOn = 'btn-outline-blue bg-blue-10';
		let cssOff = 'btn-default';
		let typeBtn = $('.btn[data-type='+data.type+']');

		form.attr('action', data.target);
		icon.attr('title', data.engine);
		icon.find("svg").attr('data-icon', data.icon.replace('fa-',''));
		input.attr('placeholder', text).attr('aria-label', text).focus();

		$(".js-change-engine-type .btn").removeClass(cssOn).addClass(cssOff);
		typeBtn.removeClass(cssOff).addClass(cssOn);

		if(data.type == 'web'){
			Cookie.set(StartPageEngineCookie, data.uri, {expires: 365});
		}
	}

	this.init();
};